var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLockAlt = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M140 15c33.137 0 60 26.863 60 60v40h10c16.569 0 30 13.431 30 30v90c0 16.569-13.431 30-30 30H70c-16.568 0-30-13.431-30-30v-90c0-16.569 13.432-30 30-30h10V75c0-33.137 26.863-60 60-60m0 160c-11.046 0-20 8.954-20 20s8.954 20 20 20 20-8.954 20-20-8.954-20-20-20m0-130c-16.569 0-30 13.432-30 30v40h60V75c0-16.568-13.431-30-30-30"
})));
export default SvgLockAlt;